// Put all packages together.
// Used to generate umd/index.prod.js

import React from 'react';
import ReactDOM from 'react-dom/client';

import { IntlProvider } from 'react-intl';

import TinodeWeb from './views/tinode-web.jsx';
import './css/base.scss'
import { language, messageLoader } from './stores/storages/LanguageStorage.js';

import './services/signal-protocol/signal-store.js'

// Insert google analytics script and tag if configured.
if (typeof FIREBASE_INIT != 'undefined' && FIREBASE_INIT && FIREBASE_INIT.measurementId) {
  const head = document.getElementsByTagName('head')[0];
  let script = document.createElement('script');
  script.src = 'https://www.googletagmanager.com/gtag/js?id=' + FIREBASE_INIT.measurementId;
  script.async = true;
  head.prepend(script);
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', FIREBASE_INIT.measurementId);
}

// Detect human language to use in the UI:
//  Check parameters from URL hash #?hl=ru, then browser, then use 'en' as a fallback.

const lang = language.language;

// Try the full locale first, then the locale without the region code, fallback to 'en'.
const htmlLang = messageLoader[lang] ? lang : 'en';

// Set lang attribute of the HTML element: <html lang="XX">
document.getElementsByTagName('html')[0].setAttribute('lang', htmlLang);
window.Buffer = require('buffer').Buffer

// window.console.log = () => {}

// Render the app.
const root = ReactDOM.createRoot(document.getElementById('root'));
messageLoader[htmlLang]().then(messages =>
  root.render(
    <IntlProvider locale={lang} messages={messages} textComponent={React.Fragment}>
      <TinodeWeb />
    </IntlProvider>
));
